import React, { useCallback, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { upcommingAppointments } from '../../../redux/appointments/actions';
import dayjs from 'dayjs';
import styles from './UpcomingAppointmentList.module.scss';
import CardContent from '@material-ui/core/CardContent';
import { Card, CardHeader, Typography } from '@material-ui/core';
import CalendarTodayIcon from '@material-ui/icons/CalendarToday';
import ScheduleIcon from '@material-ui/icons/Schedule';

const UpcomingAppointmentList = (props) => {
	const { upcommingAppointmentsArray } = props;

	return (
		<div className={styles.appointments_group}>
			<h3 className={styles.appointments_title}>Upcoming appointment</h3>
			{upcommingAppointmentsArray.map((appointment) => {
				return (
					<div
						className={styles.appointment_card}
						key={appointment.appointmentId}
					>
						<Card variant='outlined'>
							<CardContent>
								<Typography
									color='textPrimary'
									className={styles.appointment_name}
								>
									{appointment.appointmentMainName}
								</Typography>
								<Typography
									variant='body2'
									component='p'
									className={
										styles.appointment_card_main_content
									}
								>
									<div className={styles.date_group}>
										<CalendarTodayIcon />
										{dayjs(
											appointment.appointmentTime
										).format('DD/MM/YYYY')}
									</div>
									<div className={styles.time_group}>
										<ScheduleIcon />
										{dayjs(
											appointment.appointmentTime
										).format('hh:mm A')}
									</div>
								</Typography>
							</CardContent>
						</Card>
					</div>
				);
			})}
		</div>
	);
};

const mapStateToProps = (state) => ({
	upcommingAppointmentsArray: state.appointments.upcommingAppointments,
	userType: state.signIn.userType,
});

export default connect(mapStateToProps, { upcommingAppointments })(
	UpcomingAppointmentList
);
